import { useState } from 'react';
import { TableList, Typography, WithInfoIcon } from 'seagull';
import styles from "./MapAccountsRow.module.scss";
import { MapStatusView } from "../MapStatusView";
import { QBOAccountField } from "../QBOAccountField";
import { getAccountingDetails } from "../accounting.utils";
import { Accounting } from "../../../types/api.model";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MapAccountsRow(_ref) {
  let {
    anchorAccount,
    tooltip,
    accounts,
    selectedAccountId,
    onLink,
    'data-testid': testid,
    accounting = Accounting.QBO,
    noOptionsText = "No ".concat(getAccountingDetails(accounting).name, " accounts")
  } = _ref;
  const [selectedOption, setSelectedOption] = useState(() => accounts === null || accounts === void 0 ? void 0 : accounts.find(account => account.id === selectedAccountId));
  const [mapStatus, setMapStatus] = useState(() => selectedOption ? 'mapped' : 'notMapped');
  const {
    testIdPrefix
  } = getAccountingDetails(accounting);
  const onChange = async account => {
    if (!account) return;
    setMapStatus('mapping');
    setSelectedOption(account);
    try {
      await onLink(account);
      setMapStatus(account ? 'mapped' : 'notMapped');
    } catch (e) {
      setMapStatus('failedToMap');
    }
  };
  return /*#__PURE__*/_jsx(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/_jsxs("div", {
        className: styles.accountToSetColumn,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.textWrapper,
          children: [/*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            children: anchorAccount
          }), /*#__PURE__*/_jsx(Typography, {
            skin: "error",
            children: "*"
          })]
        }), /*#__PURE__*/_jsx(WithInfoIcon, {
          info: tooltip
        })]
      })
    }, {
      value: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testIdPrefix, "-accounts"),
        className: styles.autocompleteWrapper,
        children: /*#__PURE__*/_jsx(QBOAccountField, {
          "data-testid": "".concat(testid, "-autocomplete"),
          options: accounts || [],
          onChange: onChange,
          selectedOption: selectedOption,
          textFieldProps: {
            placeholder: 'Select account',
            error: mapStatus === 'failedToMap'
          },
          noOptionsText: noOptionsText
        })
      })
    }, {
      value: /*#__PURE__*/_jsx(MapStatusView, {
        mapStatus: mapStatus
      })
    }]
  });
}